module.exports = __webpack_public_path__ + "at.no1.65124f78.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/at.no1.jpg
// module id = 5NcW
// module chunks = 0